import { render } from "./IndexSearchInput.vue?vue&type=template&id=5ec207cc"
import script from "./IndexSearchInput.vue?vue&type=script&lang=js"
export * from "./IndexSearchInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IndexSearchInput.vue"]])

export default __exports__